export default "__VITE_ASSET__BP26zVyc__"